import React from 'react'
import { Button, Modal } from 'react-bootstrap'

import StoryDetails from './StoryDetails'
import OnlyCoverContent from './OnlyCoverContent'

class SlideShowContent extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			callPermissions: 'initial',
			subContentExpanded: true,
			chooseContentTypeModalVisible: false,
			contentType: 'Story',
			selectedtype: 'Story',
			selectedPageIndex: [],
			pages: [],
			autoSlide: false,
			autoSlideSeconds: '',
		}
		this.story = {}
	}
	chooseTypeAndAddNewPage = () => {
		this.setState({ chooseContentTypeModalVisible: true })
	}
	toggleAutoSlide = () => {
		this.setState({ autoSlide: !this.state.autoSlide }, () => {
			this.props.updateInParent('autoSlideOn', this.state.autoSlide, 'SlideShow')
		})
	}
	handleAutoSlideSeconds = (e) => {
		const seconds = e.target.value
		this.setState({ autoSlideSeconds: seconds }, () => {
			this.props.updateInParent(
				'autoSlideSeconds',
				parseInt(this.state.autoSlideSeconds),
				'SlideShow'
			)
		})
	}
	removePage = (pageIndex) => {
		const { pages } = this.state

		pages.splice(pageIndex, 1)

		this.props.updateInParent('pages', pages, 'SlideShow')
		this.setState({ pages: pages })

		if (pages && pages.length > 0) {
			const storyTitle = pages[0].storyDetails && pages[0].storyDetails.storyTitle
			const storyCardDescription =
				pages[0].storyDetails && pages[0].storyDetails.storyCardDescription
			const coverStoryTitle =
				pages[0].pageType == 'CoverStory'
					? pages[0].coverStoryDetails &&
					pages[0].coverStoryDetails.onlyCoverDetails.coverStoryTitle
					: ''
			const coverStoryCardDescription =
				pages[0].pageType == 'CoverStory'
					? pages[0].coverStoryDetails &&
					pages[0].coverStoryDetails.onlyCoverDetails.coverStoryCardDescription
					: ''
			const slideShowTitle = pages[0].pageType == 'Story' ? storyTitle : coverStoryTitle
			const slideShowDescription =
				pages[0].pageType == 'Story' ? storyCardDescription : coverStoryCardDescription
			const storyImage =
				pages[0].storyDetails.storyCardImages &&
				pages[0].storyDetails.storyCardImages[0] &&
				pages[0].storyDetails.storyCardImages[0].image
			const coverStoryImage =
				pages[0].coverStoryDetails.onlyCoverDetails.coverStoryImages &&
				pages[0].coverStoryDetails.onlyCoverDetails.coverStoryImages[0] &&
				pages[0].coverStoryDetails.onlyCoverDetails.coverStoryImages[0].image
			const slideShowImage =
				pages[0].pageType == 'Story'
					? storyImage
					: pages[0].pageType == 'CoverStory'
						? coverStoryImage
						: ''

			// TO DO console.log(slideShowTitle, 'titleeeeeeeeeeeee storyyyyyyyyyyyy')
			// TO DO console.log(slideShowImage, 'slideShowImage storyyyyyyyyyyyy')
			this.props.updateInParent('slideShowDescription', slideShowDescription, 'SlideShow')
			this.props.updateInParent('slideShowTitle', slideShowTitle, 'SlideShow')
			if (slideShowImage) {
				this.props.updateInParent('slideShowImage', slideShowImage, 'SlideShow')
			} else {
				this.props.updateInParent('slideShowImage', '', 'SlideShow')
			}
		}
	}
	setPageExpanded = (pageIndex) => {
		const pageIndexes = this.state.selectedPageIndex
		const index = pageIndexes.indexOf(pageIndex)
		if (index > -1) {
			pageIndexes.splice(index, 1)
		} else {
			pageIndexes.push(pageIndex)
		}
		this.setState({ selectedPageIndex: pageIndexes })
	}
	closeModalAndSetContentType = () => {
		const page = this.state.pages
		const item = {
			id: page.length,
			pageType: this.state.selectedtype,
		}
		const currentOpenPage = page.length
		if (this.state.selectedtype == 'Comment') {
			page.push(item)
			this.setState(
				{
					chooseContentTypeModalVisible: false,
					pages: page,
					contentType: this.state.selectedtype,
					selectedPageIndex: [currentOpenPage],
				},
				() => {
					page.map((item) => {
						delete item.id
					})
					this.props.updateInParent('pages', page, 'SlideShow')
				}
			)
		} else {
			item.storyDetails = {}
			item.coverStoryDetails = {
				flipToStoryDetails: {},
				onlyCoverDetails: {},
				inAppBrowserDetails: {},
			}
			item.pollDetails = {}
			item.mcqDetails = {}
			page.push(item)
			this.setState(
				{
					chooseContentTypeModalVisible: false,
					pages: page,
					contentType: this.state.selectedtype,
					selectedPageIndex: [currentOpenPage],
				},
				() => {
					this.props.updateInParent('pages', page, 'SlideShow')
				}
			)
		}
	}
	closeContentTypeModal = () => {
		this.setState({ chooseContentTypeModalVisible: false })
	}
	handleSetPageType = (selectedtype) => {
		this.setState({ selectedtype: selectedtype })
	}
	updateSlideShowPages = (slideShowpages, key) => {
		this.props.updateInParent('pages', slideShowpages, 'SlideShow')
		if (slideShowpages && slideShowpages.length > 0) {
			let slideShowTitle
			let slideShowDescription
			let slideShowImage
			if (slideShowpages[0].pageType == 'Story') {
				if (key.includes('storyTitle')) {
					slideShowTitle = slideShowpages[0].storyDetails && slideShowpages[0].storyDetails[key]
				}
				if (key.includes('storyCardDescription')) {
					slideShowDescription =
						slideShowpages[0].storyDetails && slideShowpages[0].storyDetails[key]
				}
				slideShowImage =
					slideShowpages[0].storyDetails.storyCardImages &&
					slideShowpages[0].storyDetails.storyCardImages[0] &&
					slideShowpages[0].storyDetails.storyCardImages[0].image
			} else {
				if (key.includes('coverStoryCardDescription')) {
					slideShowDescription =
						slideShowpages[0].coverStoryDetails &&
						slideShowpages[0].coverStoryDetails.onlyCoverDetails[key]
				}
				if (key.includes('coverStoryTitle')) {
					slideShowTitle =
						slideShowpages[0].coverStoryDetails &&
						slideShowpages[0].coverStoryDetails.onlyCoverDetails[key]
				}
				slideShowImage =
					slideShowpages[0].coverStoryDetails.onlyCoverDetails.coverStoryImages &&
					slideShowpages[0].coverStoryDetails.onlyCoverDetails.coverStoryImages[0] &&
					slideShowpages[0].coverStoryDetails.onlyCoverDetails.coverStoryImages[0].image
			}
			this.props.updateInParent('slideShowDescription', slideShowDescription, 'SlideShow')
			this.props.updateInParent('slideShowTitle', slideShowTitle, 'SlideShow')
			if (slideShowImage) {
				this.props.updateInParent('slideShowImage', slideShowImage, 'SlideShow')
			} else {
				this.props.updateInParent('slideShowImage', '', 'SlideShow')
			}
		}
	}
	updateStoryDetails = (key, value, type, page, index) => {
		const slideShowpages = this.state.pages
		slideShowpages.map((eachPage, pageIndex) => {
			eachPage.mcqDetails = {}
			eachPage.pollDetails = {}
			if (index == pageIndex && eachPage.storyDetails) {
				eachPage.storyDetails[key] = value
			}
		})
		this.setState({ pages: slideShowpages })
		console.log(key, value, slideShowpages, 'key, value, slideShowpages==')
		this.updateSlideShowPages(slideShowpages, key, value)
	}
	updateCoverStoryDetails = (key, value, type, page, index) => {
		const slideShowpages = this.state.pages

		slideShowpages.map((eachPage, pageIndex) => {
			eachPage.mcqDetails = {}
			eachPage.pollDetails = {}
			if (index == pageIndex && eachPage.coverStoryDetails) {
				eachPage.coverStoryDetails.onlyCoverDetails[key] = value
			}
		})
		this.setState({ pages: slideShowpages })
		this.updateSlideShowPages(slideShowpages, key, value)
	}
	componentDidMount() {
		const { editContent } = this.props
		if (editContent) {
			const { pages, autoSlideOn, autoSlideSeconds } = this.props.slideShowDetails
			this.setState({
				autoSlide: autoSlideOn,
				autoSlideSeconds: autoSlideSeconds,
				pages: pages,
			})
		}
	}
	componentDidUpdate = (prevProps, prevState) => {
		if (this.props.contentSelectedLangVal != prevProps.contentSelectedLangVal) {
			const { editContent } = this.props
			if (editContent) {
				const { pages } = this.props.slideShowDetails

				this.setState({
					pages: pages,
				})
			}
		}
	}
	renderChooseContentTypeModal = () => {
		const { chooseContentTypeModalVisible, selectedtype } = this.state
		return (
			<Modal show={chooseContentTypeModalVisible} onHide={() => this.closeContentTypeModal()}>
				<Modal.Body>
					<div style={{ marginRight: 10 }}>
						<input
							value={'Story'}
							type='radio'
							checked={selectedtype == 'Story'}
							onClick={() => {
								this.handleSetPageType('Story')
							}}
						></input>
						<text for={'Story'}>{'Story'}</text>
					</div>
					<div style={{ marginRight: 10 }}>
						<input
							value={'CoverStory'}
							type='radio'
							checked={selectedtype == 'CoverStory'}
							onClick={() => {
								this.handleSetPageType('CoverStory')
							}}
						></input>
						<text for={'CoverStory'}>{'CoverStory'}</text>
					</div>
					<div style={{ marginRight: 10 }}>
						<input
							value={'Comment'}
							type='radio'
							checked={selectedtype == 'Comment'}
							onClick={() => {
								this.handleSetPageType('Comment')
							}}
						></input>
						<text for={'Comment'}>{'Comment'}</text>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<Button onClick={() => this.closeContentTypeModal()}>Cancel</Button>
					<Button onClick={() => this.closeModalAndSetContentType()}>Ok</Button>
				</Modal.Footer>
			</Modal>
		)
	}
	renderPages = () => {
		const { pages } = this.state
		return (
			<div>
				{pages && pages.map((page, index) => {
					return (
						<div key={index}>
							<text>
								{'Page '}
								{index + 1}
								{' - '}
								{page.pageType}
							</text>
							<text onClick={() => this.removePage(index)}> X </text>

							<div>
								<div>
									{page.pageType == 'Story' ? (
										<StoryDetails
											selectedContentType={'Story'}
											wordPressInfo={this.props.wordPressInfo}
											syncToWordpress={this.props.syncToWordpress}
											disableSyncToWordPress={this.props.disableSyncToWordPress}
											updateWordpressPermalink={this.props.updateWordpressPermalink}
											setFeaturedImageId={this.props.setFeaturedImageId}
											editContent={this.props.editContent}
											contentSelectedLangVal={this.props.contentSelectedLangVal}
											storyDetails={page.storyDetails ? page.storyDetails : page.story}
											updateInParent={(key, value, type) =>
												this.updateStoryDetails(key, value, type, page, index)
											}
											// contentSelectedLangVal={this.props.contentSelectedLangVal}
											updateVideodetails={this.props.updateVideodetails}
											contentID={this.props.contentID}
										/>
									) : null}
									{page.pageType == 'CoverStory' ? (
										<div>
											<OnlyCoverContent
												editContent={this.props.editContent}
												onlyCoverDetails={page.coverStoryDetails.onlyCoverDetails}
												contentSelectedLangVal={this.props.contentSelectedLangVal}
												// getDataFromChilds={getDataFromChilds}
												updateChildElements={(key, value, type) =>
													this.updateCoverStoryDetails(key, value, type, page, index)
												}
												// contentSelectedLangVal={this.props.contentSelectedLangVal}
												updateVideodetails={this.props.updateVideodetails}
												contentID={this.props.contentID}
												slideshow={true}
											/>
										</div>
									) : null}
									{page.pageType == 'Comment' ? (
										<div>
											<text>{'commentsPageAdded'}</text>
										</div>
									) : null}
								</div>
							</div>
						</div>
					)
				})}
			</div>
		)
	}
	render() {
		return (
			<div>
				<details>
					<summary>SlideShow Details</summary>

					<div>
						{this.state.pages && this.state.pages.length ? (
							<div>
								<div className='custom-control custom-switch'>
									<input
										type='checkbox'
										className='custom-control-input'
										onClick={this.toggleAutoSlide}
										checked={this.state.autoSlide}
										id='autoSlide'
										readOnly
									/>
									<label className='custom-control-label' htmlFor='autoSlide'>
										Auto Slide
									</label>
								</div>
								{this.state.autoSlide ? (
									<div>
										<div>
											<input
												type='text'
												onChange={(value) => {
													this.handleAutoSlideSeconds(value)
												}}
												value={this.state.autoSlideSeconds}
												placeholder='Auto Slide In(Seconds)'
											></input>
										</div>
									</div>
								) : null}
								{this.state.autoSlide && this.state.autoSlideSeconds == '' ? (
									<text for='text' style={{ color: 'red', fontSize: 10 }}>
										Auto Slide In Seconds Cannot be empty
									</text>
								) : null}
								{this.state.autoSlide && this.state.autoSlideSeconds > 10 ? (
									<text for='text' style={{ color: 'red', fontSize: 10 }}>
										Auto Slide In Seconds Cannot be greater than 10
									</text>
								) : null}
							</div>
						) : null}
						<div>
							<button onClick={() => this.chooseTypeAndAddNewPage()}>{'Add Page'}</button>
						</div>
						{this.renderPages()}
					</div>
				</details>
				{this.renderChooseContentTypeModal()}
			</div>
		)
	}
}

export default SlideShowContent
